import './GroundContact.scss'
import { useCallback, useMemo, useState } from 'react';
import GroundContactSection from './GroundContactSection';
import RightSidePanel from './RightSidePanel';
import ContactModal from './ContactModal';
import useUrlParams from '../../../../hooks/useUrlParams';
import useUrlNavigation from '../../../../hooks/useUrlNavigation';
import useContacts from '../../../../hooks/useContacts';
import useGroundContact from '../../../../hooks/useGroundContact';
import PlanningNavigation from '../PlanningNavigation';
import EmptyPage from '../../../../custom_components/EmptyPage';
import { PlusSvg } from '../../../../custom_components/Svgs';
import ContactManagementModal from './ContactManagementModal';
import useScenario from '../../../../hooks/useScenario';
import { isOperateMode, isSummaryMode } from '../../../../hooks/utils';
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../../../simulate/constants';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';


const GroundContact = () => {
    const { navigate_to } = useUrlNavigation()
    const { configured_gs } = useGroundContact()
    const { tab_name, dashboard } = useUrlParams()
    const { scenario } = useScenario()
    const operateMode = isOperateMode(dashboard, scenario)
    const summaryMode = isSummaryMode(dashboard, scenario)
    const { contacts, selectedContact } = useContacts()
    const closeModal = useCallback(() => setIsModalOpen(null), []);
    const [isModalOpen, setIsModalOpen] = useState<'create' | 'book' | null>(null);

    const [isMinimised, setIsMinimised] = useState(false);
    const [showModal, setShowModal] = useState<boolean>(false)

    const deploymentType = useMemo(() => scenario?.scenarioDeploymentType, [scenario?.scenarioDeploymentType])
    const openContactModal = useMemo(() => (showModal && configured_gs?.length) ? true : false, [showModal, configured_gs])

    if (!operateMode && configured_gs?.length === 0) {
        return (
            <EmptyPage content='No Ground Contacts' >
                {deploymentType && (
                    <div className='planning__container__header ground__container__header__container'>
                        <PlanningNavigation deploymentType={deploymentType} activeTab={tab_name} onNavigate={navigate_to} />
                    </div>
                )}
            </EmptyPage>
        )
    }

    return (
        <div className='planning__container__body'>
            <div className='ground__station__contact__container'>
                <div className='ground__container__left__container__wrapper'>
                    {deploymentType && (
                        <div className='planning__container__header ground__container__header__container'>
                            <PlanningNavigation deploymentType={deploymentType} activeTab={tab_name} onNavigate={navigate_to} />
                            <div className='ground__container__header__right__container' />
                        </div>
                    )}
                    <GroundContactSection />
                    {operateMode && !summaryMode && scenario?.scenarioDeploymentType?.toUpperCase() !== SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER && (
                        <CustomToolTip title="Create Contact" placement="top" className='add__contact__tooltip'>
                            <button
                                className="add__contact__button"
                                onClick={() => setIsModalOpen('create')}
                                >
                                    <PlusSvg />
                                </button>
                            </CustomToolTip>
                        )}
                </div>
                <RightSidePanel set_show_modal={() => { setShowModal(true) }} all_contacts={contacts} selected_contact={selectedContact}
                    setIsModalOpen={setIsModalOpen} />


            </div>

            <ContactModal open={openContactModal} close={setShowModal} selected_contact={selectedContact} />
            <ContactManagementModal
                isOpen={isModalOpen}
                onClose={closeModal}
                isMinimised={isMinimised}
                setIsMinimised={setIsMinimised}
            />
        </div>
    )
}

export default GroundContact
